import { makeStyles, shorthands } from '@fluentui/react-components';

export const useViewSelectorStyles = makeStyles({
  container: {
    maxWidth: '300px',
    display: 'flex',
    flexGrow: '0',
    justifyContent: 'flex-end',
    ...shorthands.gap('5px'),
  },
  button: {
    width: 'fit-content',
    minWidth: 'auto',
    ...shorthands.padding('0px'),
  },
  buttonText: {
    ...shorthands.overflow('hidden'),
    lineBreak: 'anywhere',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
});
